import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth } from '../contexts/AuthContext';
import { getStoredDriverMobileUser } from '../utils/driverMobileSession';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  const storedDriverMobileUser = (() => {
    try {
      return getStoredDriverMobileUser<any>();
    } catch {
      return null;
    }
  })();

  const effectiveUser = user || storedDriverMobileUser;
  const effectiveRole = effectiveUser?.role || storedDriverMobileUser?.role || storedDriverMobileUser?.driverType;

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-sm text-gray-500">Oturum kontrol ediliyor...</div>
      </div>
    );
  }

  // Giriş yapmamışsa sürücü giriş sayfasına yönlendir
  if (!isAuthenticated) {
    return <Navigate to="/driver-mobile-auth" state={{ from: location }} replace />;
  }

  const effectiveRoles = Array.from(new Set([effectiveUser?.role, ...(effectiveUser?.roles || []), ...(effectiveUser?.roleIds || []), ...(effectiveUser?.role_ids || [])].filter(Boolean)));
  const isCorporateSubUser = effectiveRoles.includes('corporate-external-transport-user') || (effectiveRoles.includes('corporate-external-transport') && Boolean(effectiveUser?.externalTransportAccountUserId || effectiveUser?.external_transport_account_user_id));
  const isDriverRole = isCorporateSubUser || effectiveRole === 'external-driver' || effectiveRole === 'corporate-external-transport-driver' || effectiveRole === 'internal-driver' || effectiveRole === 'driver' || effectiveRole === 'internal';
  if (isDriverRole && !location.pathname.startsWith('/driver-mobile')) {
    return <Navigate to="/driver-mobile-home" replace />;
  }

  // Layout içinde sayfa bazlı permission kontrolü yapılacak
  return <>{children}</>;
}
